import React, { useEffect, useState } from 'react'
import axios from 'axios'
import ArticleList from '../Archive/ArticleList'
import config from '../../config/config'
import { useParams, useRouteMatch } from 'react-router-dom'


const Tag = () => {
  const [journals, setJournals] = useState([])
  const { tag } = useParams()
  const { path, url } = useRouteMatch()

  useEffect(() => {
    async function getJournals(tag) {
      const url = `${config.host}/journals/tags/${tag}`
      const { data: journals } = await axios.get(url)
      setJournals(newestFirst(journals))
    }
    return getJournals(tag)
  }, [tag])

  return (
    <div className="flex-grow">
      <div className="px-4 py-6 mx-12 my-6">
        <h1 className="text-5xl font-black text-gray-900">{tag}</h1>
      </div>
      <div>
        <ArticleList
          journals={journals}
          path={path}
          url={url}
        />
      </div>
    </div>
  )
}


function newestFirst(journals) {
  if (!Array.isArray(journals)) return journals
  const postedAt = (journal) => Date.parse(journal?.createdAt) || 0
  return [...journals].sort((a, b) => postedAt(b) - postedAt(a))
}


export default Tag